import { dateIsInTheFuture } from './dates';
import { targetCaloriesFromOnboardingAnswers } from './space_onboarding';

export const spaceMembershipWithBackendUpdateMembershipResult = (
  spaceMembership,
  updateMembershipResponse,
) => {
  if (!spaceMembership || !updateMembershipResponse) {
    return spaceMembership;
  }
  if (updateMembershipResponse.spaceMembershipID !== spaceMembership.id) {
    console.warn(
      `Space membership ID mismatch: ${updateMembershipResponse.spaceMembershipID} !== ${spaceMembership.id}`,
    );
    return spaceMembership;
  }
  if (!updateMembershipResponse.membershipExpiresAt) {
    console.warn(
      `No membership expiration date in update response for space membership ${spaceMembership.id}`,
    );
    return spaceMembership;
  }
  return {
    ...spaceMembership,
    expiresAt: updateMembershipResponse.membershipExpiresAt,
  };
};

export const isPaidAndActive = (spaceMembership) => {
  if (!spaceMembership) {
    return false;
  }
  return (
    spaceMembership.expiresAt && dateIsInTheFuture(spaceMembership.expiresAt)
  );
};

export const isSpaceOnboardingCompleted = (spaceMembership) =>
  !!spaceMembership?.onboardingAnswersLastUpdatedAt;

export const hasUserProvidedEnoughOnboardingAnswers = (spaceMembership) => {
  if (!spaceMembership || !spaceMembership.onboardingAnswers) {
    return false;
  }
  const answers = spaceMembership.onboardingAnswers;
  return answers.length > 0;
};

export const isInitialProgrammeSelectionCompleted = (spaceMembership) =>
  !!spaceMembership?.initialProgrammeSelectionLastOfferedAt;

export const currentProgrammeTargetCalories = (currentSpaceMembership) => {
  if (!currentSpaceMembership || !currentSpaceMembership.onboardingAnswers) {
    return null;
  }
  return (
    currentSpaceMembership.customTargetCalories ||
    targetCaloriesFromOnboardingAnswers(
      currentSpaceMembership.onboardingAnswers,
    )
  );
};

/*
    const loadSpaceMemberships = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (!currentUser) {
          // User not signed in
          return true;
        }
        const userId = currentUser.username;
        console.log(`Loading spaces for user ${userId}`);
        const spaceMemberships = await getSpaceMembershipsOperation(userId);
        if (
          spaceMemberships.length === 0 &&
          (!intoSpaceID || intoSpaceID === DEFAULT_SPACE_ID)
        ) {
          // const defaultSpaceMembership = spaceMemberships.find(
          //   (membership) => membership.spaceID === DEFAULT_SPACE_ID,
          // );
          // if (!defaultSpaceMembership) {
          const referrer = spaceMembershipDefaultReferrer();
          console.info(
            `Creating default space membership, referrer ${referrer}`,
          );
          const newSpaceMembership =
            await createPreactivatedSpaceMembershipOperation(
              DEFAULT_SPACE_ID,
              referrer,
            );
          spaceMemberships.push(newSpaceMembership);
          // }
        }

        return dispatch({
          type: 'SPACE_MEMBERSHIPS_AVAILABLE',
          spaceMemberships,
        });
      } catch (e) {
        console.log(e);
        return null;
      }
    };

*/
